"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;
var classes = {
  parentContainer: 'bds-progress-bar-parent-container',
  container: 'bds-progress-bar-container',
  leading: 'bds-progress-bar-leading',
  trailing: 'bds-progress-bar-trailing',
  value: 'bds-progress-bar-value'
};
exports.classes = classes;